<template>
  <div>
    <h3 @click="enableDebug($event)" class="display-4">Manage Requests</h3>

    <o-list-toolbar
      :filters-list="filter_list"
      :list-options="list_options"
      :search-fields-list="search_field_list"
      :selected-filter="selected_filter"
      @filter_changed="update_filter($event)"
      @options_changed="update_table($event)"
      @reset_table="reset_table"
    >
    </o-list-toolbar>

    <b-table
      :fields="fields"
      :items="items"
      :sort-by="list_options.sort"
      :sort-desc="list_options.order == 'desc'"
      @sort-changed="change_sort"
      bordered
      head-variant="light"
      no-local-sorting
      striped
    >
      <template slot="cell(other_name)" slot-scope="{ index, item }">
        <router-link :to="{ name: 'form_entry.edit', params: { id: item.id } }">
          <default-display
            :value="item.other_name"
            default-value="-"
          ></default-display>
        </router-link>
      </template>
      <template
        slot="cell(form_template_version__name)"
        slot-scope="{ index, item }"
      >
        <router-link :to="{ name: 'form_entry.edit', params: { id: item.id } }">
          <default-display
            :value="item.form_template_name"
            default-value="-"
          ></default-display>
        </router-link>
      </template>
      <template slot="cell(other_id)" slot-scope="{ index, item }">
        <number-display :decimals="0" :value="item.other_id" />
      </template>
      <template slot="cell(uuid)" slot-scope="{ index, item }">
        <default-display :value="item.uuid"></default-display>
      </template>
      <template slot="cell(created_date)" slot-scope="{ index, item }">
        <date-display
          :value="item.created_date"
          format="DD/MM/YYYY hh:mm"
        ></date-display>
      </template>
      <template slot="cell(modified_date)" slot-scope="{ index, item }">
        <date-display
          :value="item.modified_date"
          format="DD/MM/YYYY hh:mm"
        ></date-display>
      </template>
      <template slot="cell(created_user)" slot-scope="{ index, item }">
        <lookup-display
          :list="optionUserItemsById"
          :value="item.created_user"
          default-value="-"
          display-field="username"
        ></lookup-display>
      </template>
      <template slot="cell(submitted_user)" slot-scope="{ index, item }">
        <lookup-display
          :list="optionUserItemsById"
          :value="item.submitted_user"
          default-value="-"
          display-field="username"
        ></lookup-display>
      </template>
      <template slot="cell(sign_off_done)" slot-scope="{ index, item }">
        <boolean-display :value="item.sign_off_done"></boolean-display>
      </template>
      <template slot="cell(tags)" slot-scope="{ index, item }">
        <b-badge
          :key="tag_index"
          v-for="(tag, tag_index) in item.tags"
          variant="primary"
          >{{ tag }}</b-badge
        >
      </template>

      <template slot="empty">
        <p>
          <emoticon-sad-icon large></emoticon-sad-icon>
        </p>
        No Data Found. Please
        <router-link :to="{ name: 'form_entry.create' }"
          >create a new item</router-link
        >
      </template>
    </b-table>

    <o-list-paging
      :limit="list_options.limit"
      :offset="list_options.offset"
      :page-options="rows_per_page_items"
      :total-items="items.length"
      @change-limit="change_limit"
      @change-page="change_page"
    />
  </div>
</template>

<style></style>

<script>
import {
  CreateCodeTableFetchMixin,
  CreateGroupPermissionMixin,
  CreateListPageMixin,
} from "../../../vue-ocom/mixins";
import CodeOptionsFetchMixin from "../../../vue-ocom/mixins/CodeOptionsFetchMixin.js";
import {
  fieldToTableColumn,
  GetSearchFields,
} from "../../../vue-ocom/schema/schema_utils.js";
import schema from "../../schema/index";

import OListToolbar from "../../../vue-ocom/components/list/OListToolbar.vue";
import OListPaging from "../../../vue-ocom/components/list/OListPaging.vue";
import DefaultDisplay from "../../../vue-ocom/components/display/DefaultDisplay.vue";
import DateDisplay from "../../../vue-ocom/components/display/DateDisplay.vue";
import NumberDisplay from "../../../vue-ocom/components/display/NumberDisplay.vue";
import BooleanDisplay from "../../../vue-ocom/components/display/BooleanDisplay.vue";
import LookupDisplay from "../../../vue-ocom/components/display/LookupDisplay.vue";
import EmoticonSadIcon from "vue-material-design-icons/EmoticonSad.vue";
import EmailIcon from "vue-material-design-icons/Email.vue";
import LinkIcon from "vue-material-design-icons/Link.vue";
import { cleanUpModel } from "../../../vue-ocom/schema/schema_vuetify.js";

export default {
  components: {
    EmoticonSadIcon,
    EmailIcon,
    LinkIcon,
    OListPaging,
    OListToolbar,
    DateDisplay,
    DefaultDisplay,
    BooleanDisplay,
    NumberDisplay,
    LookupDisplay,
  },
  mixins: [
    CreateListPageMixin("FormEntry", "form_entry"),
    CreateGroupPermissionMixin("FormEntry"),
    CreateCodeTableFetchMixin(["User", "FormTemplateVersion"]),
  ],

  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.FormEntry,
        {}
      ) /*Use this.schema instead */,

      search_field_list: GetSearchFields(schema.FormEntry),

      filter_list: [
        {
          name: "Assigned",
          code: "assigned",
          options: { offset: 0, sort: "created_date" },
        },
      ],
    };
  },
  computed: {
    fields() {
      return [
        fieldToTableColumn(this.schema, "form_template_version__name"),
        fieldToTableColumn(this.schema, "created_date"),
        fieldToTableColumn(this.schema, "modified_date"),
        fieldToTableColumn(this.schema, "submitted_user"),
      ];
    },
  },
};
</script>
